import type { Embed, Tidal } from '@tunasong/models'
import type { EmbedSizes } from './types.js'

/** Example URLs

 */

const urlMatch = /^https:\/\/tidal\.com\/browse\/(\w+)\/([\w-]+)(\?.*)?$/
const iFrameMatch = /^\<iframe src=\"https:\/\/embed.tidal.com\/(\w+)\/(\w+)\"/

const sizes: EmbedSizes = {
  small: {
    width: '50%',
    height: '80px',
  },
  medium: {
    width: '100%',
    height: '80px',
  },
  large: {
    width: '100%',
    height: '300px',
  },
}

export const parseTidalLink = (urlOrUrn?: string): Embed | null => {
  if (!urlOrUrn) {
    return null
  }
  const trimmed = urlOrUrn.trim()
  const match = trimmed.match(urlMatch) ?? trimmed.match(iFrameMatch)
  const mediaType = match?.[1] as string | undefined
  const mediaId = match?.[2]
  if (!(mediaId && mediaType)) {
    return null
  }
  const mediaTypePlural = mediaType.endsWith('s') ? mediaType : `${mediaType}s`
  const node: Tidal = {
    type: 'embed',
    service: 'tidal',
    url: `https://embed.tidal.com/${mediaTypePlural}/${mediaId}`,
    mediaId,
    size: 'medium',
    children: [{ text: '' }],
  }
  return node
}
/**
 * <iframe src="https://embed.tidal.com/tracks/427786828" width="500" height="120" allow="encrypted-media" sandbox="allow-same-origin allow-scripts allow-forms allow-popups" title="TIDAL Embed Player" />

 */

export default {
  parse: parseTidalLink,
  sizes,
}
